export default {
    "cod" : [
        { "key" : "SHIPPING" ,    "txt" : "เข้าระบบ" },
        { "key" : "TRANSFERRED" , "txt": "โอนเงินคืนแล้ว" }
    ]
}